import { actionType } from '../actions/invoice';
import baseInitState from '../baseInitState';
import baseReducer from '../baseReducer';

const initState = {
  ...baseInitState,
};

export default function invoice(state = initState, action) {
  switch (action.type) {
    default:
      return baseReducer(state, action, actionType);
  }
}
